class TimelineSection {
    constructor(element) {
        this.element = element;
        this.accordionHeaders = element.querySelectorAll('.timeline-accordion__header');
        this.timelineItems = element.querySelectorAll('.timeline-item');

        this.init();
    }

    init() {
        this.accordionHeaders.forEach(header => {
            header.addEventListener('click', (e) => this.toggleAccordion(e));
        });
        this.timelineItems.forEach(item => {
            item.addEventListener('click', (e) => this.toggleTimeLineItem(e));
        });
    }

    toggleTimeLineItem(e){
        const header = e.currentTarget;
        const item = header.closest('.timeline-item__wrapper');
        const content = item.querySelector('.timeline-item__content');
        const isActive = item.classList.contains('timeline-item__wrapper--active');

        if (isActive) return;

        const items = [...this.element.querySelectorAll('.timeline-item__wrapper')];

        const firstRects = items.map(el => el.getBoundingClientRect());

        items.forEach(timelineItem => {
            timelineItem.classList.remove('timeline-item__wrapper--active');
            timelineItem.setAttribute('aria-expanded', 'false');
        });

        if (!isActive) {
            item.classList.add('timeline-item__wrapper--active');
            header.setAttribute('aria-expanded', 'true');
            content.removeAttribute('hidden');
        }

        requestAnimationFrame(() => {
            const lastRects = items.map(el => el.getBoundingClientRect());

            items.forEach((el, i) => {
                const first = firstRects[i];
                const last = lastRects[i];

                const deltaX = first.left - last.left;
                const deltaY = first.top - last.top;
                const deltaW = first.width / last.width;
                const deltaH = first.height / last.height;

                el.style.transform = `
                    translate(${deltaX}px, ${deltaY}px)
                    scale(${deltaW}, ${deltaH})
                `;

                el.style.transition = 'transform 0s';

                requestAnimationFrame(() => {
                    el.style.transform = '';
                    el.style.transition = 'transform 0.3s ease';
                });
            });
        });
    }

    toggleAccordion(e) {
        const header = e.currentTarget;
        const item = header.closest('.timeline-accordion__item');
        const content = item.querySelector('.timeline-accordion__content');
        const isActive = item.classList.contains('timeline-accordion__item--active');

        // Close all items
        this.element.querySelectorAll('.timeline-accordion__item').forEach(accordionItem => {
            accordionItem.classList.remove('timeline-accordion__item--active');
            accordionItem.querySelector('.timeline-accordion__header').setAttribute('aria-expanded', 'false');
            accordionItem.querySelector('.timeline-accordion__content').setAttribute('hidden', '');
        });

        // Open clicked item if it wasn't active
        if (!isActive) {
            item.classList.add('timeline-accordion__item--active');
            header.setAttribute('aria-expanded', 'true');
            content.removeAttribute('hidden');
        }
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    const timelineSections = document.querySelectorAll('.timeline-section');
    timelineSections.forEach(section => new TimelineSection(section));
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const section = event.target.querySelector('.timeline-section');
        if (section) new TimelineSection(section);
    });
}